var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "v-row",
        { attrs: { wrap: "" } },
        [
          _c("v-col", { attrs: { cols: "12", sm: "6" } }, [
            _c("input", {
              attrs: { name: this.field.fieldName, type: "text", disabled: "" },
              domProps: { value: this.viewModelImage.value },
            }),
          ]),
          _vm._v(" "),
          _c("v-col", { attrs: { cols: "12" } }, [
            _c("img", {
              staticStyle: { "max-height": "200px" },
              attrs: {
                alt: "Image from photo library",
                src: _vm.generatePath(this.viewModelImage.value),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-btn", { on: { click: _vm.selectNewImage } }, [
                _vm._v("Choose Image"),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    href: _vm.imageURL,
                    target: "_blank",
                    disabled: !this.field.value,
                  },
                },
                [_c("v-icon", [_vm._v("image")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ies-coral ies-dark-gray--text",
                  attrs: { disabled: !this.field.value },
                  on: { click: _vm.unlinkImage },
                },
                [_vm._v("Remove Image")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.displayWhiteOut
            ? _c("v-col", { staticClass: "white-out", attrs: { cols: "12" } }, [
                _vm._v(" "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.displayImagePicker
            ? _c(
                "div",
                {
                  staticStyle: {
                    position: "fixed",
                    top: "10vh",
                    left: "5vw",
                    width: "90vw",
                    height: "80vh",
                    "background-color": "white",
                    "z-index": "5",
                    padding: "5rem",
                  },
                },
                [
                  _c("h2", [_vm._v("Image Library")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mt-2",
                      staticStyle: {
                        "overflow-y": "scroll",
                        height: "60vh",
                        padding: "1px",
                      },
                    },
                    [
                      _c(
                        "v-expansion-panels",
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c("v-expansion-panel-header", [
                                _c(
                                  "strong",
                                  [
                                    _vm._v("Filters "),
                                    _c("v-icon", [_vm._v("filter_list")]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-expansion-panel-content", [
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Properties")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "ID",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.searchFilters.imageKey,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchFilters,
                                                    "imageKey",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchFilters.imageKey",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Minimum Width (px)",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.searchFilters.minWidth,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchFilters,
                                                    "minWidth",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchFilters.minWidth",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Minimum Height (px)",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.searchFilters.minHeight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchFilters,
                                                    "minHeight",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchFilters.minHeight",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label: "Image Type",
                                                items: _vm.imageTypes,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.searchFilters.imageType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchFilters,
                                                    "imageType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchFilters.imageType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label: "Display Type",
                                                items: _vm.displayTypes,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.searchFilters.displayType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchFilters,
                                                    "displayType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchFilters.displayType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Relationships")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Hotel Code",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.searchFilters.hotelCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchFilters,
                                                    "hotelCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchFilters.hotelCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "6" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label: "Trip",
                                                items: _vm.trips,
                                                clearable: "",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.searchFilters.trip_key,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.searchFilters,
                                                    "trip_key",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "searchFilters.trip_key",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Image Tags")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { attrs: { wrap: "" } },
                                      [
                                        _vm._l(
                                          _vm.imageKeywordOptions,
                                          function (tag, index) {
                                            return _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: index } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(tag.label) + ": "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: tag.isTicked,
                                                      expression:
                                                        "tag.isTicked",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    float: "right",
                                                  },
                                                  attrs: {
                                                    type: "checkbox",
                                                    id: index,
                                                    label: tag.label,
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      tag.isTicked
                                                    )
                                                      ? _vm._i(
                                                          tag.isTicked,
                                                          null
                                                        ) > -1
                                                      : tag.isTicked,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a = tag.isTicked,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              tag,
                                                              "isTicked",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              tag,
                                                              "isTicked",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          tag,
                                                          "isTicked",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "a",
                                            {
                                              attrs: { href: "/keywords/list" },
                                            },
                                            [_vm._v("Manage Keywords")]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Date Range")]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "bold" }, [
                                      _vm._v("Date From:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-date-picker", {
                                      attrs: {
                                        landscape: true,
                                        color: "lime",
                                        type: "date",
                                      },
                                      model: {
                                        value: _vm.searchFilters.dateFrom,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchFilters,
                                            "dateFrom",
                                            $$v
                                          )
                                        },
                                        expression: "searchFilters.dateFrom",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "bold" }, [
                                      _vm._v("Date Until:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-date-picker", {
                                      attrs: {
                                        landscape: true,
                                        color: "lime",
                                        type: "date",
                                      },
                                      model: {
                                        value: _vm.searchFilters.dateUntil,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchFilters,
                                            "dateUntil",
                                            $$v
                                          )
                                        },
                                        expression: "searchFilters.dateUntil",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        {
                          staticClass: "mt-4",
                          attrs: { wrap: "", "no-gutters": "" },
                        },
                        _vm._l(
                          _vm.libraryImages,
                          function (libraryImage, image_key) {
                            return _c(
                              "v-col",
                              {
                                key: image_key,
                                staticClass: "pt-3 pl-1 pr-1",
                                attrs: { cols: "12", sm: "6", md: "3" },
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "clickable pa-3",
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.chooseImage(
                                          libraryImage.image_key
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("v-card-text", { staticClass: "pa-0" }, [
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c("b", [_vm._v("ID:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(libraryImage.image_key) +
                                            "\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mb-2",
                                          staticStyle: { "overflow-x": "auto" },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              "max-height": "150px",
                                            },
                                            attrs: {
                                              alt: "Image from photo library",
                                              src: libraryImage.image_source,
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      libraryImage.hotel
                                        ? _c("div", { staticClass: "mb-2" }, [
                                            _c("b", [_vm._v("Hotel:")]),
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  libraryImage.hotel.hotel_code
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  libraryImage.hotel.hotel_name
                                                ) +
                                                "\n                                "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c("b", [_vm._v("Display:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              libraryImage.display_slideshow
                                                ? "Yes"
                                                : "No"
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c("b", [_vm._v("Type:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              typeof libraryImage.image_type ===
                                                undefined ||
                                                libraryImage.image_type ==
                                                  null ||
                                                typeof libraryImage.image_type
                                                  .display_name_short ===
                                                  undefined
                                                ? null
                                                : libraryImage.image_type
                                                    .display_name_short
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c("b", [_vm._v("Order:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(libraryImage.sort_order) +
                                            "\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c("b", [_vm._v("Caption:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(libraryImage.caption) +
                                            "\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c("b", [_vm._v("Copyright:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(libraryImage.copyright) +
                                            "\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c("b", [_vm._v("Description:")]),
                                        _vm._v(
                                          " " +
                                            _vm._s(libraryImage.description) +
                                            "\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        libraryImage.image_keywords &&
                                        libraryImage.image_keywords.length
                                          ? _c(
                                              "span",
                                              _vm._l(
                                                libraryImage.image_keywords,
                                                function (tag, index) {
                                                  return _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            title:
                                                              tag.keyword.name,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              tag.keyword
                                                                .icon_name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                      _vm._v(" "),
                      _vm.totalItems >= 1
                        ? _c(
                            "v-row",
                            {
                              staticClass: "mt-4 white",
                              attrs: { "align-center": "" },
                            },
                            [
                              _c("v-col", [
                                _c("strong", [_vm._v("Total:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.totalItems) +
                                    " Items\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { depressed: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToFirstPage()
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("first_page")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { depressed: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToPrevPage()
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("navigate_before")])],
                                    1
                                  ),
                                  _vm._v(
                                    "\n\n                        Page " +
                                      _vm._s(_vm.pageNumber + 1) +
                                      " of " +
                                      _vm._s(_vm.totalPages) +
                                      "\n\n                        "
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { depressed: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToNextPage()
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("navigate_next")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { depressed: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToLastPage()
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("last_page")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                [
                                  _c("strong", { staticClass: "text-left" }, [
                                    _vm._v("Images per Page:"),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      "hide-details": "",
                                      dense: "",
                                      outlined: "",
                                      items: _vm.rowsPerPageOpts,
                                      label: "",
                                      "item-value": "value",
                                      "single-line": "",
                                      "justify-end": "",
                                    },
                                    model: {
                                      value: _vm.chosenRowsPerPage,
                                      callback: function ($$v) {
                                        _vm.chosenRowsPerPage = $$v
                                      },
                                      expression: "chosenRowsPerPage",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        position: "relative",
                        bottom: "0",
                        "background-color": "white",
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "span",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ies-green ies-dark-gray--text",
                              on: { click: _vm.closeImageSelector },
                            },
                            [_vm._v("Done")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            { on: { click: _vm.closeImageSelector } },
                            [_vm._v("Cancel")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          on: { click: _vm.loadLibraryImages },
                        },
                        [_c("v-icon", [_vm._v("search")]), _vm._v(" Search")],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }